import { Alert, AlertIcon, Text } from '@chakra-ui/react';
import { IRecordedInterviewEntry } from 'api-paths-cas';
import { useSelector } from 'react-redux';
import { getAuth } from '../../../../store/selectors';
import { getFormattedDate } from '../../../../utilities/scheduledInterviews';
import { isEnrolyStaff } from '../../../../utilities/roles/permissions';
interface IProps {
  interview: IRecordedInterviewEntry;
  processedVideos: number;
  questionsCount: number;
}
export default function RecordedAt({ interview, processedVideos, questionsCount }: IProps) {
  const { role } = useSelector(getAuth);
  const isAdmin = isEnrolyStaff(role);
  const sortedAttempts = Object.entries(interview.attempts)
    .map(([attemptHash, attempt]) => {
      return {
        ...attempt,
        attemptHash,
      };
    })
    .sort((a, b) => a?.timestamp - b?.timestamp);

  if (!sortedAttempts?.length) {
    return null;
  }

  const attempt = sortedAttempts[sortedAttempts.length - 1];
  const { timestamp } = attempt;
  const dateFormatted = getFormattedDate(timestamp);
  return (
    <>
      {isAdmin && questionsCount && processedVideos !== questionsCount ? (
        <Alert status="warning" mb={6}>
          <AlertIcon />
          {!processedVideos
            ? 'This video has not yet finished processing.'
            : `This video has not yet finished processing (${questionsCount - processedVideos} question(s) remaining)`}
        </Alert>
      ) : null}
      <Text mb="6">{`Recorded ${dateFormatted}`}</Text>
    </>
  );
}
